import { CONSTANT } from 'src/app/shared/constant/constant';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { PROD_DOMAIN } from './environment';

/**
 * API URL取得用キー
 */

/**
 * 共通
 */
// ログインユーザ情報取得
export const USER_AUTHINFOS = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/userauthinfos/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/userauthinfos/'
);
// ヘッダー項目生成
export const HEADER_LIST = getUrl(
  'https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/headerlist/',
  'https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/headerlist/'
);
// バリデーションチェック
export const API_URL_VALIDATION_RESULT = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/validationresult/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/validationresult/'
);
// バリデーションチェック(複数)
export const API_URL_MULTIVALIDATION_RESULT = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/multivalidationresult/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/multivalidationresult/'
);
// 画像登録
export const API_URL_UPLOAD_IMAGE = getUrl(
  'https://63p8453s40.execute-api.ap-northeast-1.amazonaws.com/prod/uploadimage/',
  'https://63p8453s40.execute-api.ap-northeast-1.amazonaws.com/prod/uploadimage/'
);
// ファイル登録
export const API_URL_UPLOAD_CSV = getUrl(
  'https://63p8453s40.execute-api.ap-northeast-1.amazonaws.com/prod/uploadcsv/',
  'https://63p8453s40.execute-api.ap-northeast-1.amazonaws.com/prod/uploadcsv/'
);
// ファイル情報登録
export const API_URL_REGIST_DATA = getUrl(
  'https://63p8453s40.execute-api.ap-northeast-1.amazonaws.com/prod/registdata/',
  'https://63p8453s40.execute-api.ap-northeast-1.amazonaws.com/prod/registdata/'
);
// ブロック実行必要回数の取得
export const API_URL_RUN_COUNT = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/runcount/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/runcount/'
);
// ブロック実行必要回数の取得(会員一覧用)
export const API_URL_RUN_COUNT2 = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/runcount2/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/runcount2/'
);
// 全辞書値取得
export const API_URL_DIC_LISTS = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/spec_code_masters/list/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/spec_code_masters/list/'
);

// ファイルアップロード（JOB登録）
export const API_URL_APPLICATIONS_FILES = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/applications/files/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/applications/files/'
);

// 郵便番号マスタ一覧
export const POSTALS_LIST = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/postals/list/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/postals/list/'
);

// 会員申請登録
export const APPLICATIONS = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/applications/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/applications/'
);

// 会員申請登録
export const GET_APPLICATION_ID_FROM_UUID = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/applications/uuid/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/applications/uuid/',
);

// 確認コードチェック（会員プロフィール、ユーザへの分離作成）
export const AUTH_CODES = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/authcodes/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/authcodes/'
);

// 認証コード再送信
export const AUTH_CODES_SEND = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/authcodes/send/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/authcodes/send/'
);

// メールアドレス入力チェック
export const EMAIL_CHECKS = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/emailchecks/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/emailchecks/'
);

// パスワード設定
export const PASSWORDS = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/passwords/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/passwords/'
);

// 入会申請詳細
export const APPLICATIONS_DETAIL = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/applications/detail/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/applications/detail/'
);

// 入会申請承認
export const APPLICATIONS_UNAPPROVE = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/member/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/member/'
);

// 未承認一覧(入会申請承認)
export const APPLICATIONS_APPROVE = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/applications/approve/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/applications/approve/'
);

// カテゴリ一覧取得
export const AGENDA_CATEGORY_LIST = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_category/list/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_category/list/'
);

// 新着情報一覧
export const WHAT_SNEWS = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/whatsnews/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/whatsnews/'
);

// 課題・ソリューション登録・更新
export const LOGIN_DONE_AGENDA_SOLUTIONS = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/'
);

// 課題・ソリューション承認
export const AGENDA_SOLUTIONS_APPROVE = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/approve/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/approve/'
);

// 課題・ソリューション件数取得
export const AGENDA_CATEGORY_COUNT = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_category/count/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_category/count/'
);

// 課題・ソリューション詳細 前回情報
export const LOGIN_NOT_AGENDA_SOLUTIONS_LOG = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solution_logs/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solution_logs/'
);

// 掲示板コメント(GET:取得 POST:登録 DELETE:削除)
export const BOARDS = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/boards/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/boards/'
);

// 掲示板コメント削除(DELETE:削除)
export const DELETE_BOARDS = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/boards/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/boards/'
);

// 掲示板コメント件数取得
export const BOARDS_COUNT = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/boards/count/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/boards/count/'
);

// マッチングリスト取得
export const AGENDA_SOLUTIONS_SUGGEST = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/suggest/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/suggest/'
);

// 提案一覧
export const SUGGEST_LIST = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/members/agenda/list/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/members/agenda/list/'
);

// 提案詳細
export const LOGIN_NOT_SUGGESTS = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/suggests/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/suggests/'
);

// 提案登録・更新
export const LOGIN_DONE_SUGGESTS = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/suggests/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/suggests/'
);

// 提案承認
export const SUGGESTS_APPROVE = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/suggests/approve/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/suggests/approve/'
);

// 提案詳細 前回情報
export const LOGIN_NOT_SUGGESTS_LOG = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/suggest_logs/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/suggest_logs/'
);

// チャットリスト取得
export const CHAT_LIST = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/chat/list/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/chat/list/'
);

// チャットコメント登録
export const CHATS = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/chats/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/chats/'
);

// 会員一覧取得
export const MEMBERS_LIST = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/members/list/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/members/list/'
);

// 会員の件数取得
export const MEMBER_COUNT = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/members/count/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/members/count/'
);

// 会員プロファイル更新
export const MEMBER_INFO_UPDATE = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/members/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/members/'
);

// 会員プロフィール詳細
export const MEMBERS_DETAIL = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/members/detail/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/members/detail/'
);

// 会員プロフィール詳細課題一覧
export const MEMBERS_AGENDA = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/members/agenda/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/members/agenda/'
);

// 会員プロフィール詳細 前回情報
export const MEMBERS_DETAIL_LOG = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/member_logs/detail/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/member_logs/detail/'
);

// ユーザ一覧取得
export const USER_LIST = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/users/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/users/'
);

// ユーザ一覧詳細
export const USER_GENERATE = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/users/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/users/'
);

// ユーザ登録
export const USER_ADD = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/users/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/users/'
);

// ユーザ編集
export const USER_EDIT = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/users/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/users/'
);

// ユーザ削除
export const USER_DELETE = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/users/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/users/'
);

// 事業化報告レポート(GET:取得 POST:登録)
export const INDUSTRIALIZATION_REPORTS = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/industrialization_reports/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/industrialization_reports/'
);

// 未承認入会申請一覧
export const UNAPPROVE_APPLICATION_LIST = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/application/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/application/'
);

// 未承認件数取得
export const UNAPPROVES_COUNT = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/'
);

// 未承認一覧（提案）
export const UNAPPROVES_SUGGEST_LIST = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/suggest/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/suggest/'
);

// 未承認一覧(課題・ソリューション)
export const UNAPPROVES_AGENDA_SOLUTION = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/agenda_solution/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/agenda_solution/'
);

// 未承認一覧(掲示板コメント)
export const UNAPPROVE_NGWORD_LIST = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/ngword/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/ngword/'
);

// 会員プロフィールマスタ管理／REST API(GET:一覧/GET:詳細)
export const API_URL_MEMBER = getUrl(
  'https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/member_user/csv/',
  'https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/member_user/csv/'
);

// 課題・ソリューションマスタ管理／REST API(GET:一覧/GET:詳細)
export const API_URL_AGENDA_SOLUTION = getUrl(
  'https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/csv/',
  'https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/csv/'
);

// 提案マスタ管理／REST API(GET:一覧/GET:詳細)
export const API_URL_SUGGEST = getUrl(
  'https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/suggests/csv/',
  'https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/suggests/csv/'
);

// 会員主催イベントマスタ管理／REST API(GET:一覧/GET:詳細)
export const API_URL_MEMBER_EVENT = getUrl(
  'https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/member_even/csv/',
  'https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/member_even/csv/'
);

// 分科会マスタ管理／REST API(GET:一覧/GET:詳細)
export const API_URL_SUBCOMMITTEE = getUrl(
  'https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/subcommitteea/csv/',
  'https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/subcommitteea/csv/'
);

// 検索項目取得／検索画面(GET)
export const API_URL_SEARCH_ITEMS = getUrl(
  'https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/searchitems/',
  'https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/searchitems/'
);

// 問い合わせ一覧(POST)／検索画面(GET)/検索画面
export const API_INQUIRY_LIST = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/inquiry/list/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/inquiry/list/'
);

// 問い合わせ詳細(GET)
export const INQUIRY_INFO = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/inquiry/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/inquiry/'
);

// 問い合わせ登録・更新
export const INQUIRYS = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/inquirys/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/inquirys/'
);

// ユーザーマスタ管理／REST API(GET:一覧/GET:詳細)
export const API_URL_USER = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/agenda_solution/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/agenda_solution/'
);

// ユーザーマスタ管理／検索画面(GET)
export const API_URL_SEARCH_USER = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/agenda_solution/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/agenda_solution/'
);

// お知らせ一覧取得
export const INFORMATION_LIST = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/information/list/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/information/list/'
);

// お知らせ詳細
export const INFORMATION_DETAIL = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/informations/detail/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/informations/detail/'
);

// お知らせ登録
export const INFORMATION_INSERT = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/informations/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/informations/'
);

// 分科会一覧
export const SUBCOMMITTEE_LIST = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/list/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/list/'
);

// 分科会詳細
export const SUBCOMMITTEE_DETAIL = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/detail/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/detail/'
);

// 分科会申請登録
export const SUBCOMMITTEE = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/'
);

// 分科会詳細 前回情報
export const SUBCOMMITTEE_DETAIL_LOG = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee_logs/detail/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee_logs/detail/'
);

// 会員主催イベント登録(POST)
export const API_MEMBER_EVENTS_POST = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/member_events/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/member_events/'
);

// 分科会イベント／お知らせ一覧(GET)
export const SUBCOMMITTEE_EVENT_NOTICE_LIST = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/event/list2/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/event/list2/'
);

// 会員主催イベント更新(PUT)
export const API_MEMBER_EVENTS_PUT = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/member_events/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/member_events/'
);

// 未承認一覧（会員主催イベント）(GET:検索)
export const UNAPPROVES_MEMBER_EVENT = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/member_event/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/member_event/'
);

// 新着情報一覧(GET)
export const WHATSNEWS_LIST = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/whatsnews/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/whatsnews/'
);

// 会員主催イベント詳細(POST/ params: member_event_id)
export const MEMBER_EVENTS_DETAIL = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/member_events/detail/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/member_events/detail/'
);

// 会員主催イベント検索(POST)
export const MEMBER_EVENTS_LIST = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/memberevent/list2',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/memberevent/list2'
);

// 問い合わせ承認
export const INQUIRYS_APPROVE = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/inquirys/approve/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/inquirys/approve/'
);

// 会員プロフィール申請
export const MEMBERS_PROFILE_APPROVE = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/members/approve/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/members/approve/'
);

// 掲示板コメント承認
export const BOARDS_APPROVE = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/boards/approve/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/boards/approve/'
);

// 分科会承認
export const SUBCOMMITTEE_APPROVE = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittees/approve/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittees/approve/'
);

// 分科会参加登録
export const SUBCOMMITTEE_JOIN = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/join/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/join/'
);

// 分科会申請表示期間チェック(GET)
export const SUBCOMMITTEE_PERIOD_CHECK = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/checkperiod',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/checkperiod'
);

// 未承認一覧（分科会）
export const SUBCOMMITTEE_APPLICATION = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/subcommittee/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/subcommittee/'
);

// 会員主催イベント承認
export const APPROVE_MEMBER_EVENTS = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/member_events/approve/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/member_events/approve/'
);

// 未承認一覧（問い合わせ）(GET：検索)
export const UNAPPROVES_INQUIRY = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/inquiry/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/inquiry/'
);

// 分科会申請更新(PUT:更新)
export const SUBCOMMITTEE_UPDATE = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/'
);

// 未承認一覧（会員更新）(GET)
export const MEMBER_UNAPPROVES = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/member/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/member/'
);

// 会員プロフィール未登録項目チェック(GET)
export const NEEDINPUT_STATUS = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/inputchecks/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/inputchecks/'
);

// 連携事例登録(POST) 連携事例更新(PUT)
export const COOPERATIONS = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations'
);

// 連携事例更新(PUT)
export const COOPERATION_UPLOAD = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/'
);

// 連携事例一覧(POST)
export const COOPERATION_LIST = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/list/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/list/'
);

// 連携事例詳細(POST)
export const COOPERATION_DETAIL = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/detail/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/detail/'
);

// 連携事例応募期間チェック(GET)
export const COOPERATION_PERIOD_CHECK = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/checkperiod',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/checkperiod'
);

// 未承認一覧(連携事例)(GET)
export const UNAPPROVES_COOPERATION = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/cooperation/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/cooperation/'
);

// 連携事例 ステータス承認
export const COOPERATION_APPROVE = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/approve/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/approve/'
);

// 連携事例 登録
export const COOPERATION_REGIST = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/regist/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/regist/'
);

// 連携事例詳細 前回情報
export const COOPERATION_DETAIL_LOG = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/cooperation_logs/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/cooperation_logs/'
);

// 連携事例詳細 カウントアップ
export const COOPERATION_COUNTUP = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/countup/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/countup/'
);

// 連携事例件数取得(POST)
export const COOPERATION_COUNT = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/count/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/count/'
);

// 事例紹介記事一覧(POST)
export const ARTICLE_LIST = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/articles/list/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/articles/list/',
);

// 事例紹介記事詳細 カウントアップ
export const ARTICLE_COUNTUP = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/articles/countup/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/articles/countup/',
);

// 事例紹介記事件数取得(POST)
export const ARTICLE_COUNT = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/articles/count/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/articles/count/',
);

// 事例紹介記事管理(POST)
export const ARTICLE_DETAIL = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/articles/detail/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/articles/detail/',
);

// 事例紹介記事管理(POST)
export const ARTICLE_ORGANIZATION_LIST = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/articles/organization-list/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/articles/organization-list/',
);

// 事例紹介記事登録
export const ARTICLE_INSERT = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/articles/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/articles/',
);

// 課題・ソリューション登録・管理一覧取得
export const AGENDA_SOLUTIONS_ORGANIZATIONLIST = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/organizationlist',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/organizationlist'
);

// 連携事例管理(POST)
export const COOPERATION_ORGANIZATIONLIST = getUrl(
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/organizationlist',
  'https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/cooperations/organizationlist'
);

// レコメンド取得(課題・ソリューション検索画面)
export const API_URL_SEARCH_RECOMMEND = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/recommends/agenda/list/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/recommends/agenda/list/'
)

// レコメンド取得 マイページ(GET)
export const API_URL_MYPAGE_RECOMMEND = getUrl(
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/recommends/member/list/',
  'https://y53bhxj090.execute-api.ap-northeast-1.amazonaws.com/prod/recommends/member/list/'
)

// 分科会参加ユーザ一覧(GET)
export const USER_LIST_SUBCOMMITTEE = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/list2/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/list2/'
)

// 分科会イベント/お知らせ一覧(GET)
export const SUBCOMMITTEE_EVENT_LIST = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/event/list2/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/event/list2/'
)

// 分科会参加状態チェック(GET)
export const CHECK_SUBCOMMITTEE_PARTICIPATION = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/cheackjoinstatus/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/cheackjoinstatus/'
)

// 分科会参加メンバー区分変更(PUT)
export const CATEGORY_CHANGE_SUBCOMMITTEE = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/join/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/join/'
)

// 分科会退会(DELETE)
export const DELETE_SUBCOMMITTEE_MEMBER = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/leave/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/leave/'
)

// 主催/参加分科会一覧取得(GET)
export const API_URL_ORGANIZER_SUBCOMMITTEE = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/joinlist/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/joinlist/'
)

// 分科会参加者一覧(GET)
export const SUBCOMMITTEE_MEMBER_LIST = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/joinlist2',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/joinlist2'
)

// 分科会登録：継続分科会一覧取得(GET)
export const API_URL_MY_SUBCOMMITTEE = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/list3/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/subcommittee/list3/'
)

// ダッシュボード サマリー1 (GET)
export const DASHBOARD_SUMMARY1 = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/summary1',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/summary1'
)
// ダッシュボード(会員：会員数)(GET)
export const DASHBOARD_MEMBER = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/member',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/member'
)
// ダッシュボード（会員）：ID/PWD設定済U団体数 (GET)
export const DASHBOARD_MEMBER2 = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/member2',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/member2'
)
// ダッシュボード（会員）：ID/PWD設定済UU数 (GET)
export const DASHBOARD_USER = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/user',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/user'
)
// ダッシュボード（会員）：月間ログインU団体数(GET)
export const DASHBOARD_LOGIN_MEMBER = getUrl(
  "https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/loginmember",
  "https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/loginmember"
)

// ダッシュボード（会員）：月間ログインUU数(GET)
export const DASHBOARD_LOGIN_USER = getUrl(
  "https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/loginuser",
  "https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/loginuser"
)
// ダッシュボード（会員）：課題登録団体数（累計）(GET)
export const DASHBOARD_AGENDA_SOLUTION = getUrl(
  "https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution",
  "https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution"
)
// ダッシュボード（マッチング）：Summary(GET)
export const DASHBOARD_SUMMARY2 = getUrl(
  "https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/summary2",
  "https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/summary2"
)
// ダッシュボード（マッチング）：課題・ソリューション登録件数(GET)
export const DASHBOARD_AGENDA_SOLUTION_2 = getUrl(
  "https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution2",
  "https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution2"
)
// ダッシュボード（マッチング）：提案登録件数(GET)
export const DASHBOARD_SUGGEST = getUrl(
  "https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/suggest",
  "https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/suggest"
)
// ダッシュボード（マッチング）：意見交換希望件数(GET)
export const DASHBOARD_OPINION_EXCHANGE = getUrl(
  "https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/opinionexchange",
  "https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/opinionexchange"
)
// ダッシュボード（マッチング）：連携開始件数(GET)
export const DASHBOARD_COOP = getUrl(
  "https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/coop",
  "https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/coop"
)
// ダッシュボード（会員）：会員数のCSV(GET)
export const DASHBOARD_MEMBER_CSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/member/csv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/member/csv"
)
// ダッシュボード（会員）：会員数のCSV(POST) ステートマシンが実行するLambda(DBから取得したデータをS3に格納する)
export const DASHBOARD_MEMBER_CSV_USE_STATEMACHINE = getUrl(
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/member/csvputs3",
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/member/csvputs3"
)
// ダッシュボード（会員）：会員数のCSV(StateMachine) ステートマシンのARN(Lambdaの実行状態を管理する)
export const DASHBOARD_MEMBER_CSV_STATEMACHINEARN = getUrl(
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchMember_summary_memberResult_putS3",
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchMember_summary_memberResult_putS3",
)
// ダッシュボード（会員）：ID/PWD設定済U団体数のCSV(GET)
export const DASHBOARD_PWD_SETTING_U_CSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/member2/csv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/member2/csv"
)
// ダッシュボード（会員）：ID/PWD設定済U団体数のCSV(POST) ステートマシンが実行するLambda(DBから取得したデータをS3に格納する)
export const DASHBOARD_PWD_SETTING_U_CSV_USE_STATEMACHINE = getUrl(
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/member2/csvputs3",
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/member2/csvputs3"
)
// ダッシュボード（会員）：ID/PWD設定済U団体数のCSV(StateMachine) ステートマシンのARN(Lambdaの実行状態を管理する)
export const DASHBOARD_PWD_SETTING_U_CSV_STATEMACHINE = getUrl(
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchUser_summary_memberResult_putS3",
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchUser_summary_memberResult_putS3",
)
// ダッシュボード（会員）：ID/PWD設定済UU数のCSV(GET)
export const DASHBOARD_PWD_SETTING_UU_CSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/user/csv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/user/csv"
)
// ダッシュボード（会員）：ID/PWD設定済UU数のCSV(POST) ステートマシンが実行するLambda(DBから取得したデータをS3に格納する)
export const DASHBOARD_PWD_SETTING_UU_CSV_USE_STATEMACHINE = getUrl(
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/user/csvputs3",
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/user/csvputs3"
)
// ダッシュボード（会員）：ID/PWD設定済UU数のCSV(StateMachine) ステートマシンのARN(Lambdaの実行状態を管理する)
export const DASHBOARD_PWD_SETTING_UU_CSV_STATEMACHINE = getUrl(
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchUser_summary_member_userResult_putS3",
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchUser_summary_member_userResult_putS3",
)
// ダッシュボード（会員）：月間ログインU団体数のCSV(GET)
export const DASHBOARD_MONTH_LOGIN_U_CSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/loginmember/csv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/loginmember/csv"
)
// ダッシュボード（会員）：月間ログインU団体数のCSV(POST) ステートマシンが実行するLambda(DBから取得したデータをS3に格納する)
export const DASHBOARD_MONTH_LOGIN_U_CSV_USE_STATEMACHINE = getUrl(
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/loginmember/csvputs3",
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/loginmember/csvputs3"
)
// ダッシュボード（会員）：月間ログインU団体数のCSV(StateMachine) ステートマシンのARN(Lambdaの実行状態を管理する)
export const DASHBOARD_MONTH_LOGIN_U_CSV_STATEMACHINE = getUrl(
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchLogin_summary_memberResult_putS3",
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchLogin_summary_memberResult_putS3",
)
// ダッシュボード（会員）：月間ログインUU数のCSV(GET)
export const DASHBOARD_MONTH_LOGIN_UU_CSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/loginuser/csv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/loginuser/csv"
)
// ダッシュボード（会員）：月間ログインUU数のCSV(POST) ステートマシンが実行するLambda(DBから取得したデータをS3に格納する)
export const DASHBOARD_MONTH_LOGIN_UU_CSV_USE_STATEMACHINE = getUrl(
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/loginuser/csvputs3",
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/loginuser/csvputs3"
)
// ダッシュボード（会員）：月間ログインUU数のCSV(StateMachine) ステートマシンのARN(Lambdaの実行状態を管理する)
export const DASHBOARD_MONTH_LOGIN_UU_CSV_STATEMACHINE = getUrl(
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchLogin_summary_member_userResult_putS3",
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchLogin_summary_member_userResult_putS3",
)
// ダッシュボード（会員）：課題登録団体数（累計）のCSV(GET)
export const DASHBOARD_AGENDA_REGIST_ORGANIZATION_CSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution/csv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution/csv"
)
// ダッシュボード（会員）：課題登録団体数（累計）のCSV(POST) ステートマシンが実行するLambda(DBから取得したデータをS3に格納する)
export const DASHBOARD_AGENDA_REGIST_ORGANIZATION_CSV_USE_STATEMACHINE = getUrl(
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution/csvputs3",
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution/csvputs3"
)
// ダッシュボード（会員）：課題登録団体数（累計）のCSV(StateMachine) ステートマシンのARN(Lambdaの実行状態を管理する)
export const DASHBOARD_AGENDA_REGIST_ORGANIZATION_CSV_STATEMACHINE = getUrl(
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchAgenda_solution_summary_memberResult_putS3",
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchAgenda_solution_summary_memberResult_putS3",
)
// ダッシュボード（マッチング）：課題登録件数CSV(GET)
export const DASHBOARD_AGENDA_REGIST_CSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution2/csv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution2/csv"
)
// ダッシュボード（マッチング）：課題登録件数CSV(POST) ステートマシンが実行するLambda(DBから取得したデータをS3に格納する)
export const DASHBOARD_AGENDA_REGIST_CSV_USE_STATEMACHINE = getUrl(
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution2/csvputs3",
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution2/csvputs3"
)
// ダッシュボード（マッチング）：課題登録件数CSV(StateMachine) ステートマシンのARN(Lambdaの実行状態を管理する)
export const DASHBOARD_AGENDA_REGIST_CSV_STATEMACHINEARN = getUrl(
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchAgenda_solution_summary_member_agenda_solutionResult_putS3",
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchAgenda_solution_summary_member_agenda_solutionResult_putS3",
)
// ダッシュボード（マッチング）：ソリューション登録件数CSV(GET)
export const DASHBOARD_SOLUTION_REGIST_CSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution2/csv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution2/csv"
)
// ダッシュボード（マッチング）：ソリューション登録件数CSV(POST) ステートマシンが実行するLambda(DBから取得したデータをS3に格納する)
export const DASHBOARD_SOLUTION_REGIST_CSV_USE_STATEMACHINE = getUrl(
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution2/csvputs3",
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution2/csvputs3"
)
// ダッシュボード（マッチング）：ソリューション登録件数CSV(StateMachine) ステートマシンのARN(Lambdaの実行状態を管理する)
export const DASHBOARD_SOLUTION_REGIST_CSV_STATEMACHINEARN = getUrl(
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchAgenda_solution_summary_member_agenda_solutionResult_putS3",
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchAgenda_solution_summary_member_agenda_solutionResult_putS3",
)
// ダッシュボード（マッチング）：提案登録件数CSV(GET)
export const DASHBOARD_SUGGEST_REGIST_CSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/suggest/csv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/suggest/csv"
)
// ダッシュボード（マッチング）：提案登録件数CSV(POST) ステートマシンが実行するLambda(DBから取得したデータをS3に格納する)
export const DASHBOARD_SUGGEST_REGIST_CSV_USE_STATEMACHINE = getUrl(
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/suggest/csvputs3",
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/suggest/csvputs3"
)
// ダッシュボード（マッチング）：提案登録件数CSV(StateMachine) ステートマシンのARN(Lambdaの実行状態を管理する)
export const DASHBOARD_SUGGEST_REGIST_CSV_STATEMACHINEARN = getUrl(
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchSuggest_summary_m_a_sResult_putS3",
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchSuggest_summary_m_a_sResult_putS3",
)
// ダッシュボード（マッチング）：意見交換希望件数CSV(GET)
export const DASHBOARD_OPINION_EXCHANGE_CSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/opinionexchange/csv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/opinionexchange/csv"
)
// ダッシュボード（マッチング）：意見交換希望件数CSV(POST) ステートマシンが実行するLambda(DBから取得したデータをS3に格納する)
export const DASHBOARD_OPINION_EXCHANGE_CSV_USE_STATEMACHINE = getUrl(
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/opinionexchange/csvputs3",
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/opinionexchange/csvputs3"
)
// ダッシュボード（マッチング）：意見交換希望件数CSV(StateMachine) ステートマシンのARN(Lambdaの実行状態を管理する)
export const DASHBOARD_OPINION_EXCHANGE_CSV_STATEMACHINEARN = getUrl(
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchSuggest_match_summary_m_a_sResult_putS3",
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchSuggest_match_summary_m_a_sResult_putS3",
)
// ダッシュボード（マッチング）：連携開始件数のCSV(GET)
export const DASHBOARD_COOPERATION_START_CSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/coop/csv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/coop/csv"
)
// ダッシュボード（マッチング）：連携開始件数CSV(POST) ステートマシンが実行するLambda(DBから取得したデータをS3に格納する)
export const DASHBOARD_COOPERATION_START_CSV_USE_STATEMACHINE = getUrl(
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/coop/csvputs3",
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/coop/csvputs3"
)
// ダッシュボード（マッチング）：連携開始件数CSV(StateMachine) ステートマシンのARN(Lambdaの実行状態を管理する)
export const DASHBOARD_COOPERATION_START_CSV_STATEMACHINEARN = getUrl(
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchIndustrialization_report_summary_m_a_sResult_put3",
  "arn:aws:states:ap-northeast-1:585120442446:stateMachine:StateMachine_SearchIndustrialization_report_summary_m_a_sResult_put3",
)
// ダッシュボード（会員）：会員数の集計CSV(GET)
export const DASHBOARD_MEMBER_SUMCSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/member/sumcsv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/member/sumcsv"
)
// ダッシュボード（会員）：ID/PWD設定済U団体数の集計CSV(GET)
export const DASHBOARD_PWD_SETTING_U_SUMCSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/member2/sumcsv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/member2/sumcsv"
)
// ダッシュボード（会員）：ID/PWD設定済UU数の集計CSV(GET)
export const DASHBOARD_PWD_SETTING_UU_SUMCSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/user/sumcsv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/user/sumcsv"
)
// ダッシュボード（会員）：月間ログインU団体数の集計CSV(GET)
export const DASHBOARD_MONTH_LOGIN_U_SUMCSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/login/sumcsv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/login/sumcsv"
)
// ダッシュボード（会員）：月間ログインUU数の集計CSV(GET)
export const DASHBOARD_MONTH_LOGIN_UU_SUMCSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/login/sumcsv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/login/sumcsv"
)
// ダッシュボード（会員）：課題登録団体数（累計）の集計CSV(GET)
export const DASHBOARD_AGENDA_REGIST_ORGANIZATION_SUMCSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution/sumcsv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda_solution/sumcsv"
)
// ダッシュボード（マッチング）：課題登録件数集計CSV(GET)
export const DASHBOARD_AGENDA_REGIST_SUMCSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda/sumcsv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/agenda/sumcsv"
)
// ダッシュボード（マッチング）：ソリューション登録件数集計CSV(GET)
export const DASHBOARD_SOLUTION_REGIST_SUMCSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/solution/sumcsv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/solution/sumcsv"
)
// ダッシュボード（マッチング）：提案登録件数集計CSV(GET)
export const DASHBOARD_SUGGEST_REGIST_SUMCSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/suggest/sumcsv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/suggest/sumcsv"
)
// ダッシュボード（マッチング）：意見交換希望件数集計CSV(GET)
export const DASHBOARD_OPINION_EXCHANGE_SUMCSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/opinionexchange/sumcsv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/opinionexchange/sumcsv"
)
// ダッシュボード（マッチング）：連携開始件数の集計CSV(GET)
export const DASHBOARD_COOPERATION_START_SUMCSV = getUrl(
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/coop/sumcsv",
  "https://9qybx39413.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/coop/sumcsv"
)
// ダッシュボード：CSV生成のためのS3データ読込(GET)
export const DASHBOARD_READ_JSON_FROM_S3 = getUrl(
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/readJsonFromS3",
  "https://8h2mt4ouh8.execute-api.ap-northeast-1.amazonaws.com/prod/dashboards/readJsonFromS3"
)

export const ADD_AGENDA_SOLUTION_FOLLOWER= getUrl(
  "https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solution_followers",
  "https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solution_followers"
)

export const DELETE_AGENDA_SOLUTION_FOLLOWER = getUrl(
  "https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solution_follower/{0}/{1}",
  "https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solution_follower/{0}/{1}"
)

export const GET_AGENDA_SOLUTION_FOLLOWER= getUrl(
  "https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solution_followers/",
  "https://6cdwfbjy81.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solution_followers/"
)

export const DUPLICATE_AGENDA_SOLUTION= getUrl(
  "https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/duplicate/",
  "https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/duplicate/"
)

export const LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC = getUrl(
  "https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/",
  "https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/",
)

export const AGENDA_SOLUTIONS_LIST_CLOSE_LOGIC = getUrl(
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/list/',
  'https://8h4tjltz09.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/list/',
);

// 掲示板スレッド一覧
export const MESSAGE_BOARD_THREADS_LIST = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/threads/list/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/threads/list/',
);

// 掲示板スレッド件数取得
export const MESSAGE_BOARD_THREADS_COUNT = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/threads/count/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/threads/count/',
);

// 掲示板スレッド閲覧
export const MESSAGE_BOARD_THREADS_SHOW = getUrl(
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/threads/show/',
  'https://4euunjxrmf.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/threads/show/',
);

// 掲示板スレッド登録・更新・削除
export const LOGIN_MESSAGE_BOARD_THREADS_NEW = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/threads/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/threads/',
);

// 掲示板スレッド書き込み登録・更新・削除
export const LOGIN_MESSAGE_BOARD_POSTS_NEW = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/threads/posts/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/threads/posts/',
);

// 掲示板通報登録・更新・削除
export const LOGIN_MESSAGE_BOARD_REPORT = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/report/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/report/',
);

// 掲示板スレッド登録・更新・削除
export const LOGIN_MESSAGE_BOARD_THREADS_VIEW_UPDATE = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/threads/view_count/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/threads/view_count/',
);

// 未承認一覧(連携事例)(GET)
export const UNAPPROVES_MESSAGE_BOARD_REPORT = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/message_boards/report/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/message_boards/report/',
);

// 掲示板通報詳細(GET)
export const MESSAGE_BOARD_REPORT_INFO = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/report/detail/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/report/detail/',
);

// 掲示板通報承認
export const MESSAGE_BOARD_REPORT_APPROVE = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/report/approve/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/report/approve/',
);

// 会員団体種類取得
export const GET_USER_MEMBER_CLASS = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/user/member/class/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/user/member/class/',
);

// 話を聞きたい送信
export const LOGIN_REQUEST_MORE_DETAILS = getUrl(
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/request/details/',
  'https://o1sc6wchxl.execute-api.ap-northeast-1.amazonaws.com/prod/message_boards/request/details/',
);

// url取得(検証、本番取得)
export function getUrl(devUrl: string, prodUrl: string): string {
  // エンドポイント判定
  let endPoint = PROD_DOMAIN == window.location.host ? prodUrl : devUrl;

  // エンドポイントが設定されたか否か
  if (!endPoint) {
    // エンドポイントが設定されなかった場合

    console.error(
      this.msg(
        MESSAGE_CODE.E80000,
        PROD_DOMAIN == window.location.host ? '本番用' : '開発用'
      )
    );

    return CONSTANT.EMPTY_STRING;
  }

  return endPoint;
}
